
import {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";
import { TDataOilfield} from "./usePDOilfield";
import {getNirData} from "../utils/utils";
import {TData} from "./usePDGeothermal";
import {CALCULATED_FUNCTIONS, TCalculatedFunction} from "../utils/consts";

export interface IRow {
	id: number;
	chemicalElement?: string;
	NIR?: number;
	importValue?: number;
	consumption?: number;
	country?: string;
}

export type TNir = IRow[];

export interface NirBar {
		element: string,
		percent: number,
		type: "geothermal" | "oilfield" | "import"

}
export const useNIR = () => {
		const [data, setData] = useState<{nirData: TNir, geothermalData: TData, oilfieldData: TData }>(
			{nirData: [], geothermalData: [], oilfieldData: []}
		);
		const [calculatedData, setCalculatedData] = useState<NirBar[]>();
		const [calculatedFunction, setCalculatedFunction] = useState<TCalculatedFunction>(CALCULATED_FUNCTIONS[0]);
		const [loading, setLoading] = useState(true);

		useEffect(() => {
				const fetchData = async () => {
						try {
								setLoading(true);
								const nir = await axios.get(`${API_BASE}/import`, {
									headers: {
										'content-type': 'application/json',
									}
								});

								const geothermal = await axios.get(`${API_BASE}/concentration/geothermal`, {
									headers: {
										'content-type': 'application/json',
									}
								});

								const oilfield = await axios.get(`${API_BASE}/concentration/oilfield`, {
									headers: {
										'content-type': 'application/x-www-form-urlencoded',
									}
								});

							setData({nirData: nir.data, geothermalData: geothermal.data.data, oilfieldData: oilfield.data.data});

						} catch (error) {
								console.error(error);
						} finally {
								setLoading(false);
						}
				};
				fetchData();

		}, []);

		useEffect(() => {
				const calculatedData = getNirData(data, calculatedFunction);
				setCalculatedData(calculatedData);
		}, [data, calculatedFunction]);

		return {
			data,
			calculatedData,
			loading,
			setData,
			calculatedFunction,
			setCalculatedFunction
		};
}